

exports.__esModule = true;
exports.$guestThrottle = $guestThrottle;

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

function $guestThrottle(flowName, token, lang, country, mfid) {
    var models = {};

    function redirectToXoon() {
        return (0, _squid.$dispatch)('xoon', {
            exp: flowName,
            token: token,
            'locale.x': lang + '_' + country,
            'country.x': country,
            mfid: mfid
        });
    }

    function fallback(product, reason, params) {
        throw new _squid.$FallbackError({
            product: product || 'ux',
            reason: reason,
            entryPoint: flowName,
            params: params
        });
    }

    function checkWpsSubscriptionGuestEnabled() {
        return (0, _squid.$pxp)('xo_subscription_hermes_xoon', 'xo_subscription_treatment_xoon', undefined, false, true).then(function (result) {
            var treatmentName = result && result.treatment_name;

            return treatmentName === 'xo_subscription_treatment_xoon';
        });
    }

    function isGuestFlowEnabled() {
        return (0, _squid.$populate)(models, {
            checkoutAppData: _index.$CheckoutAppDataModel.instance(token).retrieve()
        }).then(function () {
            var appData = models.checkoutAppData;

            // For WPS subscription flows , enable guest flows if treatment name is returned else fallback
            if (appData && appData.is_wps_subscription_flow()) {
                return checkWpsSubscriptionGuestEnabled();
            } else {
                return _angular.$q.resolve(true);
            }
        });
    }

    return isGuestFlowEnabled().then(function (res) {
        if (!res) {
            _logger.$logger.info(flowName + '_to_ux_wps');
            return fallback('ux', flowName + '_to_ux_wps');
        }
        return redirectToXoon();
    });
}

angular.value("$guestThrottle", $guestThrottle);
_angular.$q;

_logger.$logger;

_squid.$dispatch;

_squid.$populate;

_squid.$FallbackError;

_squid.$pxp;

_index.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/guestThrottle.js
// module id = ./pages/xo-login/guestThrottle.js
// module chunks = 0